import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: "app-priority-cell-renderer",
    template: `
    <span class="tmwf-priority-text" [style.color]="textColor">
      {{ displayValue }}
    </span>
  `,
    styles: [
        `
           .tmwf-priority-text {
             font-size: 13px;
             font-weight: 500;
             font-family: "Poppins", sans-serif;
             white-space: nowrap;
           }
         `,
    ],
    standalone: false
})
export class PriorityCellRendererComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;
  displayValue = "";
  textColor = "";

  // API priority_name values 'Low' / 'Medium' / 'High' lowercase to these keys.
  private priorityStyles: Record<string, { text: string }> = {
    high: { text: "#ef4444" },
    medium: { text: "#f97316" },
    low: { text: "#22c55e" },
  };

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const val = ((params.value as string) || "").toLowerCase();
    const style = this.priorityStyles[val] || { text: "#6b7280" };
    this.textColor = style.text;
    this.displayValue = val.charAt(0).toUpperCase() + val.slice(1);
  }

  refresh(): boolean {
    return false;
  }
}
